// extracted by mini-css-extract-plugin
export default {"box":"styles_box__VHQO1","none":"styles_none__T6iLE","container":"styles_container__-wdVR"};